import { camelizeKeys } from "humps";
import type { GetSmartModulesRequestResponse } from "wagAPI";
import type { GetSmartModulesParsedResponse } from "webApp";
export const getSmartModulesResponseParser = (response: GetSmartModulesRequestResponse): GetSmartModulesParsedResponse => ({
  modules: camelizeKeys(response.partner) || []
});
export default getSmartModulesResponseParser;